(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'facebook';

    function safe_start() {
        if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.fbq) return;


        // Facebook Globals

        window.fbq = window.fbq || function() {
            return (window.fbq.callMethod) ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = !0;
        window.fbq.version = '2.0';
        window.fbq.queue = [];


        function get_product_obj(data) {

            if (!data.item) return;

            var product = {
                content_ids: [data.item.sku],
                content_type: 'product',
                content_name: data.item.sku + ": " + data.item.name
            };

            return product;
        }

        mL_events.subscribe('view.item', function(msg, data_in) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data_in);

            var data_out = get_product_obj(data_in);

            if (!data_out.content_type) {
                return mL_errors(new Error(key + ' - view.item called with no item'));
            }

            fbq('track', 'ViewContent', data_out);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { msg: msg, data_in: data_in, data_out: data_out });
        });


        mL_events.subscribe('page', function(msg, data_in) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data_in);

            fbq('track', 'PageView');
        });

        mL_events.subscribe('cart.add_item', function(msg, data_in) {

            var data_out = get_product_obj(data_in);

            if (!data_out.content_type) {
                return mL_errors(new Error(key + ' - cart.add_item called with no item'));
            }

            fbq('track', 'AddToCart', data_out);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { msg: msg, data_in: data_in, data_out: data_out });
        });

        mL_events.subscribe('form.submit', function(msg, data_in) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data_in);

            if (!data_in.data || !data_in.data.form) return;

            var data_out = { content_name: data_in.data.form };

            fbq('track', 'Lead', data_out);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { msg: msg, data_in: data_in, data_out: data_out });
        });

        mL_events.subscribe('order.pageview', function(msg, data_in) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data_in);

            var _url = data_in.url;

            if (_url.indexOf('confirmation') === -1) return;

            if (_url.indexOf('login-register') !== -1) {
                fbq('track', 'CompleteRegistration');
            } else if (_url.indexOf('opc') !== -1) {
                fbq('track', 'InitiateCheckout');
            } else if (_url.indexOf('review') !== -1) {
                fbq('track', 'AddPaymentInfo');
            }

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { msg: msg, data_in: data_in });

        });

        mL_events.subscribe('order.confirmation', function(msg, data_in) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data_in);
            var _order = data_in.order;

            var data_out = {
                content_type: 'product',
                content_ids: _order.skus,
                value: _order.revenue,
                currency: _order.currency,
                order_id: _order.order_id
            };

            if (!data_in.is_dev) fbq('track', 'Purchase', data_out);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { msg: msg, data_in: data_in, data_out: data_out });
        });


        mL.fbq = mL.fbq || {};

        mL.fbq.init = function() {
            if (mL.fbq.is_init || !mL.add_tracker || !window.fbq) return false;

            fbq('init', '710006952449865');

            mL.add_tracker('https://connect.facebook.net/en_US/fbevents.js', 'facebook');

            mL.fbq.is_init = true;

            if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
        };
    }

    try {
        safe_start();
    } catch (err) {
        mL_errors(new Error('safe_start failed - ' + key.toUpperCase()));
        mL_errors(err);
    }


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));